import { configureRequest, replacePathVariables } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CompleteDeliveryErrorResponse,
  CompleteDeliveryRequest,
  CompleteDeliverySuccessResponse
} from './completeDelivery.types'

export const completeDeliveryApi = async (
  request: CompleteDeliveryRequest
): Promise<CompleteDeliverySuccessResponse> => {
  const response = await configureRequest({
    url: replacePathVariables(urls.fulfillmentOrders.completeDelivery, { orderId: request.orderId }),
    method: 'POST',
    data: {},
    headers: {
      'X-User-Role': UserRole.traveler
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CompleteDeliverySuccessResponse
  } else {
    throw response as CompleteDeliveryErrorResponse
  }
}

export default completeDeliveryApi
